import React from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { openWorkOrder, setIsWorkOrderSucceeded } from '../WelcomeBlock/welcomeBlockSlice';
import { isMobile } from 'react-device-detect';
import { WorkOrderStatus } from './WorkOrderEnum';
import { createReportPopuopDevices } from '../../../utilities/reports/createReport';

const DevicesServiceBoxPopUp = (props) => {
  function closePopUp() {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    props.showPopup(false);
  }

  const openWorkOrderHandler = () => {
    var data = {
      workOrderCode: props.workOrderCodeInput,
      workOrderTeam: props.workOrderTeamInput,
      productPrice: props.productPriceInput,
      productInfo: props.productInfoInput,
    };
    const workOrderRes = props.openWorkOrder(data);

    return workOrderRes;
  };



  if (props.devices === WorkOrderStatus.START) {
    return (
      <div className='devices-service-box-popup'>
        <h4 className='service-box-popup-header'>בחרת מוצר מעולה </h4>
        <div className='txt-block'>שנציג יצור איתך קשר?</div>
        <div className='btns'>
          {isMobile && (
            <Container>
              <Row style={{ flexWrap: 'inherit' }}>
                <Col className='pr-0'>
                  <BtnSubmit
                    onclick={() => {
                      openWorkOrderHandler(),
                      createReportPopuopDevices('Yes Clicked', props.productInfoInput);
                    }}
                    text='כן, תודה'
                  />
                </Col>
                <Col>
                  <BtnWhite
                    style={{ height: '50px' }}
                    className='h-50'
                    text={isMobile ? 'חזרה לאזור אישי' : 'אין צורך'}
                    onclick={() => {
                      closePopUp(), 
                      createReportPopuopDevices('No Clicked', props.productInfoInput);
                    }}
                  />
                </Col>
              </Row>
            </Container>
          )}
          {!isMobile && (
            <Container>
              <Row style={{ flexWrap: 'inherit' }}>
                <Col>
                  <BtnWhite
                    style={{ height: '50px' }}
                    className='h-50'
                    text={isMobile ? 'חזרה לאזור אישי' : 'אין צורך'}
                    onclick={() => {
                      closePopUp(), createReportPopuopDevices('No Clicked', props.productInfoInput);
                    }}
                  />
                </Col>
                <Col className='pr-0'>
                  <BtnSubmit
                    onclick={() => {
                      openWorkOrderHandler(),
                        createReportPopuopDevices('Yes Clicked', props.productInfoInput);
                    }}
                    text='כן, תודה'
                  />
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    );
  } else if (props.devices === WorkOrderStatus.SUCCESS) {
    createReportPopuopDevices('Success', props.productInfoInput);
    return (
      <div className='devices-service-box-popup'>
        <h4 className='service-box-popup-header'>פנייתך הועברה לצוותון</h4>
        <div className='txt-block'>נציג יחזור אליך תוך 2 ימי עסקים</div>
        <div className='btns single-btn'>
          <Container>
            <Row style={{}}>
              <Col className='pr-0 pl-0'>
                <BtnSubmit onclick={() => closePopUp()} text='סיום' />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  } else if (props.devices === WorkOrderStatus.FAIL) {
    createReportPopuopDevices('Fail', props.productInfoInput);
    return (
      <div className='devices-service-box-popup'>
        <h4 className='service-box-popup-header'>משהו קרה ופנייתך לא נשלחה</h4>
        <div className='txt-block'>באפשרותך לנסות שוב או לפנות לאיש הקשר מארגונך</div>
        <div className='btns single-btn'>
          <Container>
            <Row style={{}}>
              <Col className='pr-0 pl-0'>
                <BtnSubmit onclick={() => closePopUp()} text='סיום' />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    devices: state.welcomeBlock.welcomeState.workOrderState,
  };
};

const mapDispatchToProps = {
  openWorkOrder,
  setIsWorkOrderSucceeded,
};

export default connect(mapStateToProps, mapDispatchToProps)(DevicesServiceBoxPopUp);
